export default __webpack_public_path__ + "static/media/amazon-negative.0e3bc66f.svg";